import { message } from 'antd';
import { axiosInstance } from '../Api';
import { Position } from 'deck.gl';
import { ConvertHexToRGBA, DatasetColors } from '../../utils/common';
import { IPolygonLayer } from '../../types/map';
export default class DownloadRequest {
  private endPoint = 'DownloadRequest';

  async getAllMoodSpaceDefinition(datasetIds: string[]) {
    try {
      const r = await axiosInstance.post(
        `/${this.endPoint}/GetAllMoodSpaceDefinition`,
        {
          datasetIdList: datasetIds,
        }
      );

      if (datasetIds.length !== r.data.MoodSpaces.length) {
        message.error(
          'GetAllMoodSpaceDefinition result format is not correct!'
        );
        return;
      }
      const datasetZones = new Array<IPolygonLayer>();

      for (let i = 0; i < datasetIds.length; i++) {
        const coordinates = new Array<Position>();
        (r.data.MoodSpaces[i] as string).split(',').forEach((stringPoint) => {
          const point = stringPoint.split(' ').map((c) => {
            return parseFloat(c);
          });
          coordinates.push([point[0], point[1]]);
        });

        datasetZones.push({
          id: datasetIds[i],
          coordinates: coordinates,
          lineColor: ConvertHexToRGBA(DatasetColors[i % DatasetColors.length]),
          color: [0, 0, 0, 0],
        });
      }
      return datasetZones;
    } catch (error) {
      message.error('GetAllMoodSpaceDefinition result format is not correct!');
      console.log(error);
    }
  }

  async getAllFWESpaceDefinition(datasetIds: string[]) {
    const r = await axiosInstance.post(
      `/${this.endPoint}/GetAllFweSpaceDefinition`,
      {
        datasetIdList: datasetIds,
      }
    );

    const domains = r.data.MoodSpaces;
    const keys = Object.keys(domains);
    const datasetZones = new Array<IPolygonLayer>();

    keys.forEach((key: string) => {
      const coordinates = new Array<Position>();
      const stringPoints = domains[key];
      stringPoints.forEach((stringPoint: string) => {
        const point = stringPoint.split(' ').map((c) => {
          return parseFloat(c);
        });
        coordinates.push([point[0], point[1]]);
      });
      datasetZones.push({
        id: key,
        coordinates: coordinates,
        lineColor: [188, 188, 35],
        color: [0, 0, 0, 0],
      });
    });
    return datasetZones;
  }
}
